import React from 'react';
import PropTypes from 'prop-types';
import { EachPurchase } from './Purchase.styles';
import SecondaryButton from '../../Components/Buttons/SecondaryButton/SecondaryButton.component';

const EachPurchaseEntity = ({ purchase, key, emailReceipt }) => {
  return (
    <EachPurchase key={key}>
      {purchase?.courseName && (
        <h3 className="course-name">{purchase?.courseName}</h3>
      )}
      {purchase?.courses?.length > 0 && (
        <>
          <h3>Courses:</h3>
          <div className="course-list">
            {purchase?.courses?.map((course, index) => (
              <li key={course?._id || index}>
                <span>{course?.courseName}</span>
                {course?.price && <span>${course?.price}</span>}
              </li>
            ))}
          </div>
        </>
      )}

      <div className="transaction-details">
        {purchase?.amount?.tax && (
          <p>
            Tax:
            <span className="italicSpan">
              ${Number(purchase?.amount?.tax).toFixed(2)}
            </span>
          </p>
        )}
        {purchase?.amount?.total && (
          <p>
            Total:
            <span className="italicSpan">
              ${Number(purchase?.amount?.total).toFixed(2)}
            </span>
          </p>
        )}
        {purchase?.transactionId && (
          <p>
            Transaction ID:
            <span className="italicSpan">{purchase?.transactionId}</span>
          </p>
        )}
        {purchase?.transactionDate && (
          <p>
            Transaction Date:
            <span className="italicSpan">
              {new Date(purchase?.transactionDate).toLocaleDateString()}
            </span>
          </p>
        )}
      </div>
      {purchase?.purchaser && (
        <div className="purchaser-info">
          <p>
            Purchased By:
            <span className="italicSpan">{purchase?.purchaser}</span>
          </p>
        </div>
      )}
      {purchase?.purchasedFor && (
        <div className="purchased-for">
          <p>
            Purchased For:
            <span className="italicSpan">
              {purchase?.purchasedFor?.join(', ')}
            </span>
          </p>
        </div>
      )}
      {emailReceipt && (
        <SecondaryButton
          span="Email Receipt"
          onClick={() => emailReceipt(purchase?.transactionId)}
        />
      )}
    </EachPurchase>
  );
};
EachPurchaseEntity.propTypes = {
  purchase: PropTypes.shape({
    courseName: PropTypes.string,
    totalAmount: PropTypes.number,
    transactionId: PropTypes.string,
    transactionDate: PropTypes.string,
    purchaser: PropTypes.string,
    purchasedFor: PropTypes.arrayOf(PropTypes.string),
    courses: PropTypes.arrayOf(
      PropTypes.shape({
        _id: PropTypes.string,
        courseName: PropTypes.string,
        price: PropTypes.number,
      })
    ),
    amount: PropTypes.shape({
      tax: PropTypes.number,
      total: PropTypes.number,
    }),
  }),
  key: PropTypes.number,
  emailReceipt: PropTypes.bool,
};
export default EachPurchaseEntity;
